import { DEFAULT_LANGUAGE } from '@backoffice-frontend/common'
import type { Scalars } from '@backoffice-frontend/graphql'

type DisplayNamesLocale = keyof NonNullable<Scalars['DisplayNames']['output']>

type StopNames = Partial<Record<DisplayNamesLocale, string | null>>

const DISPLAY_NAMES_LOCALES = [
  'de',
  'en',
  'no',
] as const satisfies readonly DisplayNamesLocale[]

const isDisplayNamesLocale = (
  value: string | null | undefined,
): value is DisplayNamesLocale =>
  !!value && DISPLAY_NAMES_LOCALES.includes(value as DisplayNamesLocale)

const pickName = (
  names: StopNames | null | undefined,
  language: string | null | undefined,
): string | undefined =>
  isDisplayNamesLocale(language) ? (names?.[language] ?? undefined) : undefined

export const resolveStopName = (
  names: StopNames | null | undefined,
  language: string | null | undefined,
  fallbackLanguage: string | null | undefined,
): string | undefined =>
  pickName(names, language) ??
  pickName(names, fallbackLanguage) ??
  pickName(names, DEFAULT_LANGUAGE) ??
  Object.values(names ?? {}).find(Boolean) ??
  undefined
